<template>
  <div style="background: #f4f5f7">
    <div class="settings" style="min-width: 1195px; max-width: 1440px; margin: 0 auto;">
      <div class="go-header" :style="'background:'+headSection.gradient">
        <div style="align-self:flex-end; margin: 0 auto; justify-self: center; height:300px; background-position-y: 15px;  background-position-x: 350px;  background-repeat:no-repeat;background-size:1141px 284px;background-image: url('https://gcdn.bionluk.com/uploads/message/394a772a-9a4f-4e7b-868d-a0b5311766dd.png')">
          <p class="title"><span>30 Ağustos</span> yaklaşıyor!</p>
          <p class="sub-title">İhtiyacın olabilecek tüm içerikler için yetenekli freelancer’larımız hazır! Sen hazır mısın?</p>

          <div @click="scrollToMain" style="width: 190px; margin:0 auto; cursor: pointer">
            <lottie :options="defaultOptions" :width="190" v-on:animCreated="handleAnimation"/>
          </div>
        </div>
      </div>

      <div style="background: #fff">
        <div style="width: 1195px; margin: 0 auto;">
          <div class="go-cats">
            <p class="title">30 Ağustos paylaşımın için neye ihtiyacın var?</p>
            <div class="go-cat-container">
              <div @click="selectCat(item)" class="go-cat" v-for="item in mainCategories" :style="selectedCat.id === item.id ? 'background:'+item.bgColor+'; color:'+item.textColor : 'color:#2d3640'">
                <img :src="item.image">
                <p class="cat-title">{{item.title}}</p>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div id="go-maind"></div>
      <div id="go-main" class="go-main" v-if="selectedCat.id">
        <div class="main-container">
          <div class="header-img" :style="'background-image:url(https://gcdn.bionluk.com/site/cicons/catImg/squares/bgu_long_'+selectedCat.main_category_id+'.png)'">
            <div class="step-2-text-container" :style="selectedCat.main_category_id === 3  ? 'color:#2d3640' : 'color:white'">
              <p class="step-2-title">{{selectedCat.title}}</p>
              <p class="step-2-sub-title">Bu kategoride teklif alabileceğin <span>{{ categories.find(({ id }) => id === selectedCat.main_category_id).user_count }} freelancer</span> var.</p>
            </div>

            <div v-if="categories.find(({ id }) => id === selectedCat.main_category_id).cat_users && categories.find(({ id }) => id === selectedCat.main_category_id).cat_users.length" style="display: flex; margin-right: 30px;">
              <div v-for="onlineUser in categories.find(({ id }) => id === selectedCat.main_category_id).cat_users ">
                <div>
                  <router-link
                    :to="'/'+onlineUser.username">
                    <img :alt="onlineUser.username" style="border:1px solid #bfc8d2; width: 44px; height: 44px; border-radius: 50%; margin-left: -15px;" :src="onlineUser.avatar_url">
                  </router-link>
                </div>
              </div>
              <div style="width: 45px;height: 45px;border: solid 1px #ffffff;background-color: #eaedf2; border-radius: 50%; font-size: 14px; margin-left: -15px; display: flex; align-items: center; justify-content: center;letter-spacing: -0.43px; color: #2d3640; font-weight: bold">
                +{{ categories.find(({ id }) => id === selectedCat.main_category_id).user_count - 5 }}
              </div>
            </div>



          </div>

          <p class="title" style="padding-top: 50px">{{selectedCat.detail.title}}</p>
          <p class="sub-title">{{selectedCat.detail.description}}</p>


          <div class="gigs-container" style="margin-top: 30px; ">
            <gig :item="gig" v-for="(gig, ii) in gigs" :key="ii" style="margin-bottom: 50px"></gig>
          </div>
          <loader v-if="gigs.length === 0"></loader>

          <div @click="searchGigs(selectedCat)" class="go-seemore" v-if="gigs.length && seemorediv && !seemoreLoading">
            <img src="https://gcdn.bionluk.com/site/cicons/ic-add-or-plus.svg" onload="SVGInject(this)" class="add-icon"/>
            <p class="text"> Daha fazla göster</p>
          </div>
          <loader v-if="seemoreLoading"></loader>

        </div>



      </div>
      <div id="go-main-2" class="go-main" v-else>
        <div class="main-container" v-for="(gigList, i) in gigLists" :key="i">
          <p class="title">{{gigList.title}}</p>
          <p class="sub-title">{{gigList.description}}</p>
          <div class="gigs-container" style="margin-top: 30px">
              <gig :item="gig" v-for="(gig, ii) in gigList.gigs" :key="ii" style="margin-bottom: 50px"></gig>
          </div>


          <router-link :to="gigList.info.see_more_url" class="go-seemore">
            <img src="https://gcdn.bionluk.com/site/cicons/ic-add-or-plus.svg" onload="SVGInject(this)" class="add-icon"/>
            <p class="text"> Daha fazla göster</p>
          </router-link>
        </div>

        <loader style="margin-top: 30px" v-if="gigLists.length === 0"></loader>
      </div>



      <div class="go-request" v-if="gigLists.length > 0 && pageLoaded">
        <div class="left">
          <p class="title">30 Ağustos için aradığın hizmeti veya freelancer’ı bulmakta zorlanıyor musun? O zaman sen alıcı isteği oluştur, freelancer’lar seni bulsun!</p>
          <button @click="$router.push('/panel/istekler')" class="cuper-red-button" style="margin-top: 20px">Alıcı İsteği Oluştur</button>
        </div>
        <img class="right" src="https://gcdn.bionluk.com/site/cicons/il-special-requests.svg">
      </div>

      <div style="height: 80px"></div>

    </div>
  </div>

</template>


<script>
  import Lottie from 'vue-lottie';
  import Gig from "../../../components/singleGig";
  export default {
    name: "src-pages-body-marketplace-goLanding-v1",
    components: {Gig, Lottie},
    data() {
      return {

        defaultOptions: {animationData: {"v":"4.11.1","fr":60,"ip":0,"op":87,"w":1920,"h":1080,"nm":"Comp 3","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":0,"s":[100],"e":[0]},{"t":80}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":0,"s":[956,414,0],"e":[956,524,0],"to":[0,0,0],"ti":[0,0,0]},{"t":80}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[48.117,48.849],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-11.441,-29.129],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":87,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[996,520,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[212.016,466.625],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":145,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.974448529412,0.95231143727,0.95231143727,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":20,"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-49.992,25.312],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":87,"st":0,"bm":0}]}},
        animationSpeed: 1.7,


        offset:0,
        limit:16,
        totalCount:0,
        seemorediv:true,
        gigs:[],
        gigLists:[],
        pageLoaded:true,
        seemoreLoading:false,
        headSection:{
          gradient:'linear-gradient(282deg, #b60404 4%, #b60404 100%)',
        },
        mainCategories:[
          {
            title: 'Video & Animasyon',
            detail:{
              title:'Video, Animasyon, Whiteboard',
              description:'30 Ağustos’a özel reklamın henüz hazır değilse, işlerini hızlı ve kolay bir şekilde yaptıran onbinlerce işletme arasına katılman için aşağıdaki ilanlara göz atabilirsin.',
            },
            id:4,
            main_category_id:4,
            slug:'video-animasyon',
            search_term:'30 Ağustos',
            bgColor:'#3faa40',
            textColor:'#ffffff',
            image:'https://gcdn.bionluk.com/site/cicons/catImg/ic-video.svg',
          },
          {
            title: 'Seslendirme',
            detail:{
              title:'Reklam & Tanıtım Seslendirmesi',
              description:'30 Ağustos’a özel reklamın hazır mı? O zaman ona uygun bir ses seçerek reklamının izlenebilirliğini veya dinlenebilirliğini fark yaratacak şekilde arttırabilirsin.',
            },
            id:61,
            main_category_id:5,
            search_term:'reklam',
            slug:'seslendirme',
            bgColor:'#ff4c54',
            textColor:'#ffffff',
            image:'https://gcdn.bionluk.com/site/cicons/catImg/ic-music.svg',
          },
          {
            title: 'Tasarım',
            detail:{
              title:'Sosyal Medya Gönderileri & Banner Tasarımları',
              description:'Video veya ses istemiyor fakat sosyal medya gönderisini ve banner çalışmalarını es geçmek istemeyenlerden misin? ',
            },
            id:22,
            search_term:'30 ağustos',
            main_category_id:1,
            slug:'sosyal-medya-tasarimlari',
            bgColor:'#3a59e9',
            textColor:'#ffffff',
            image:'https://gcdn.bionluk.com/site/cicons/catImg/ic-graphic-design.svg',
          },
          {
            title: 'Yazı & İçerik',
            detail:{
              title:'Makale, Yazı, Blog ve Sosyal Medya İçeriği',
              description:'Bugüne özel özgün içeriğe mi ihtiyacın var. O zaman elini çabuk tut. Çünkü doğru yerdesin. Hem hızlı hem de kaliteli içerik yazarlarımızla tanış.',
            },
            id:41,
            main_category_id:3,
            search_term:'sosyal medya',
            slug:'web-sitesi-icerigi',
            bgColor:'#ffbf00',
            textColor:'#2d3640',
            image:'https://gcdn.bionluk.com/site/cicons/catImg/ic-writing.svg',
          }
        ],
        selectedCat:{},
        header:"freelancerlar'la",
      }
    },

    methods: {


      scrollToMain(){

        document.getElementById('go-maind').scrollIntoView({
          behavior: 'smooth'
        });

      },
      handleAnimation: function (anim) {
        this.anim = anim;
        this.anim.setSpeed(this.animationSpeed);
      },

      selectCat(cat){
        if(this.selectedCat.id && this.selectedCat.id === cat.id){
          this.selectedCat = {};
        } else {
          this.selectedCat = cat;
        }
      },

      openOnboardingModal(){
        this.$store.commit(this.types.ACTIVE_MODAL, {modalType: this.Modals.ONBOARDING,info:{url:null}});
      },

      getGoPage() {
        let slug = this.$store.state.routerParams[0];
        this.api.content.getGoPage(slug)
          .then(({data}) => {
            let result = data;
            if (result.success) {
              this.$store.state.indexHTMLTitle = result.data.meta.title;
              this.$store.state.indexHTMLMetaDescription = result.data.meta.description;
              this.gigLists = result.data.gig_lists;
              this.Helper.trackEvents.pageView(this.Helper.goLandingPageProps(result.data.id, result.data.slug, result.data.title), "landingpagego");
            } else {
              this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE })
            }
          })
          .catch(() => {
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          })
      },

      searchGigs(cat, reset=false){

        if(reset){
          this.offset = 0;
          this.gigs = [];
          this.pageLoaded = false;
        } else {
          this.seemoreLoading = true;
        }
        let option = {
          slug: cat.slug,
          term: cat.search_term,
          limit: this.limit,
          offset:this.offset,
          orderBy: 1,
          count:true,
          scoringProfile:'term_search',
        };
        this.searchDeeds2(option)
          .then(result => {

            this.api.general.getGigLikes(result.results.map(res => res.id))
              .then(({data}) => {
                let likeResult = data;

                result.results.forEach(gig => {
                  let foundLike = likeResult.data.find(({ id }) => id === gig.id)
                  gig.portfolios = JSON.parse(gig.portfolios)
                  gig.likeStatus = foundLike.likeStatus;
                });



                this.gigs = [...this.gigs, ...result.results];

                if (result.count) {
                  this.totalCount = result.count;
                }
                if (!result.results.length) {
                  this.totalCount = 0;
                }

                this.offset += this.limit;
                this.seemorediv = this.offset < this.totalCount;

                this.pageLoaded = true;
                this.seemoreLoading = false;
              })
              .catch(err => {
                this.pageLoaded = true;
                this.seemoreLoading = false;
                this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
              });
          })
          .catch(err => {
            this.pageLoaded = true;
            this.seemoreLoading = false;
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          });
      }

    },

    watch: {
      selectedCat: function (newVal, oldVal) {
        if(newVal && newVal.id){
          this.searchGigs(newVal, true)
        }
      }
    },

    async created() {
      await this.$store.state.categoriesPromise
      this.getGoPage();
    }

  }
</script>

<style scoped lang="scss">


  .go-request{
    background: url("https://gcdn.bionluk.com/site/general/sl_bg%402x.png");
    background-size: cover;
    width: 1193px;
    height: 224px;
    margin: 80px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left{
      margin-left: 60px;
      .title{
        width: 520px;
        font-size: 18px;
        font-weight: normal;
        line-height: 1.67;
        color: #ffffff;
      }
      .cuper-red-button{
        width: 200px;
        height: 44px;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
      }

    }

    .right{
      margin-right: 60px;
      width: 335px;
      height: 203px;
    }

  }
  .header-img{
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    width: 1193px;
    height: 103px;
    background-repeat: no-repeat;
    background-size: 1193px;
    border-radius:10px;
  }

  .step-2-text-container{
    margin-left: 138px;
  }
  .step-2-title{
    font-size: 18px;
    font-weight: 600;

    margin-top: 5px;
  }
  .step-2-sub-title{
    font-size: 16px;
    line-height: 1.25;

    span{
      font-weight: bold;
    }
  }


  .go-main{
    background: #f4f5f7;
    width: 100%;
    .main-container{
      margin: 0 auto;
      width: 1195px;

      .title{
        padding-top: 80px;
        font-size: 32px;
        font-weight: bold;
        line-height: 1.25;
        text-align: center;
        color: #2d3640;
      }

      .sub-title{
        width: 750px;
        margin: 0 auto;
        padding-top: 10px;
        font-size: 16px;
        font-weight: normal;
        line-height: 1.88;
        text-align: center;
        color: #5e6b79;
      }
    }
  }



  .gigs-container{

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &:after {
      content: "";
      width: 278px;
    }

  }


  .go-seemore{

    width: 200px;
    margin: 0 auto;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      text-decoration: underline;
    }
    .add-icon /deep/ {
      width: 20px;
      height: 20px;
      path {
        fill: #00a575!important;
      }
    }

    .text{
      padding-left: 10px;
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #00a575;
    }
  }

  .go-header{
    width: 100%;
    height: 300px;
    margin: 0 auto;
    text-align: center;

    .inside{

    }

    .title{
      width: 800px;
      padding-top: 30px;
      margin: 0 auto;
      font-size: 60px;
      letter-spacing: -1px;
      color: #ffffff;
      font-weight: normal;
      span{
        font-weight: bold;
      }
    }

    .sub-title{
      margin:15px auto auto;
      width: 593px;
      font-size: 22px;
      font-weight: 300;
      line-height: 1.82;
      text-align: center;
      color: #ffffff;
    }
  }

  .go-cats{
    width: 100%;
    height: 250px;
    background-color: #fff;
    .title{
      padding-top: 30px;
      font-size: 28px;
      font-weight: bold;
      line-height: 1.43;
      text-align: center;
      color: #2d3640;
      span{
        font-weight: normal;
      }
    }

    .go-cat-container{

      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      .go-cat{
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 250px;
        height: 130px;
        border-radius: 6px;
        border: solid 1px rgba(191, 200, 210, 0.2);
        &:hover{
          border: solid 1px rgba(191, 200, 210, 0.8);
        }
        img{
          width: 42px;
        }
        .cat-title{
          margin-top: 15px;
          font-size: 18px;
          font-weight: 500;
        }
      }
    }

  }
</style>
